import React, { useState } from 'react'
import Text from '../../../../components/Text'
import DocumentView from './DocumentView'
import { useSelector } from 'react-redux'
import {
  supportProgramStatus,
  supportProgramTypes,
} from '../../../../constants/support-programs'
import Spinner from '../../../../components/Spinner'
import constants from '../../../../constants'
import * as coinsAnimationData from '../../../../assets/animations/coins-animate.json'
import Lottie from 'react-lottie'
// import ProceedButton from '../../../../components/Signup/ProceedButton'
import {
  coinsCount,
  document_types,
} from '../../../../constants/anaya-constants'
const UploadDocuments = ({ onMoveNext }) => {
  const { ftuDocumentsWithoutVisit: documents } = useSelector(
    (state) => state.records,
  )

  const coinsAnimationOptions = {
    loop: true,
    autoplay: true,
    animationData: coinsAnimationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }
  const supportProgram = supportProgramTypes[constants.CARE_PROGRAM_TYPE.ANAYA]
  const [uploadedDocuments, setUploadedDocuments] = useState(0)

  return (
    <div className="px-4 bg-[#F2F2F2]">
      <div className="space-y-3 pb-4">
        <div className="px-4 py-3 flex gap-2 bg-white -mx-4">
          <div className="min-w-12">
            <Lottie speed={0.7} options={coinsAnimationOptions} width={45} />
          </div>
          <Text tag="p" variant="body" size="medium" className="text-[#101828]">
            Uploading these documents starts your journey and you become
            eligible for{' '}
            <Text
              tag="span"
              variant="body"
              size="medium"
              bold={'true'}
              className="text-[#101828]"
            >
              {coinsCount} care coins
            </Text>
          </Text>
        </div>

        <div className="pb-4">
          <Text
            tag="p"
            variant="headline"
            size="small"
            className="text-[#101828] !font-[roboto]"
          >
            Upload Documents
          </Text>

          <Text tag="p" variant="body" size="medium" className="text-[#5A6774]">
            Upload the following document(s) to enter the program
          </Text>
        </div>

        {documents?.loading ? (
          <div className="flex justify-center items-center h-full">
            <Spinner />
          </div>
        ) : (
          <div className="flex flex-col gap-4 pb-4">
            {document_types.map((documentTypes) => {
              const document =
                documents?.data?.data?.find(
                  (i) => i.title === documentTypes.document_title,
                ) ?? null

              const documentStatus =
                document?.record_meta_info?.report_status ===
                supportProgramStatus.DOCUMENT_REVIEW_STATUS.REJECTED
                  ? 'rejected'
                  : document?.record_meta_info?.report_status ===
                      supportProgramStatus.DOCUMENT_REVIEW_STATUS.UNDER_REVIEW
                    ? 'under_review'
                    : 'pending'

              return (
                <DocumentView
                  key={documentTypes.document_type}
                  document={document}
                  documentType={documentTypes.document_type}
                  uploadReportType={supportProgram.upload_report_type}
                  documentStatus={documentStatus}
                  onUploadSuccess={onMoveNext}
                  documentConstObj={documentTypes}
                  setUploadedDocuments={setUploadedDocuments}
                  // afterCompletion={() => onUploadSuccess('prescription')}
                  // setIsLoaderVisible={setLoader}
                  // onDeletePress={() => onDeletePress('prescription')}
                />
              )
            })}
          </div>
        )}
      </div>

      {/* <ProceedButton
        disabled={uploadedDocuments !== document_types.length}
        onMoveNext={onMoveNext}
      /> */}
    </div>
  )
}

export default UploadDocuments
